import Vue from 'vue'
import VueRouter from 'vue-router'
import QuotationHall from '../views/QuotationHall.vue'
import { needsBrandSetup, isBrandSetupUnknown, checkUserBrandSetup, needsInviteCodePending, isUserRulesAgreed, requiresRulesAgreement, getUserInfo, hasCachedUserProfile } from '@/utils/common'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',//登录
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue')
  },
  {
    path: '/',
    redirect: '/quotationHall'  // 添加这一行，重定向根路径到抢单大厅
  },
  {
    path: '/quotationHall',//抢单大厅
    name: 'home',
    component: QuotationHall,
    meta: { requiresAuth: true }
  },
  {
    path: '/withdraw',//提现
    name: 'withdraw',
    component: () => import(/* webpackChunkName: "withdraw" */ '../views/Withdraw.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/rules',//提现
    name: 'rules',
    component: () => import(/* webpackChunkName: "rules" */ '../views/RulesPage.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/selectBrands',
    name: 'selectBrands',
    component: () => import(/* webpackChunkName: "selectBrands" */ '../views/SelectBrands.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/support',//客服
    name: 'support',
    component: () => import(/* webpackChunkName: "support" */ '../views/Support.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach(async (to, from, next) => {
  const token = localStorage.getItem('token')
  let userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
  // 未登录
  if (!token && to.meta.requiresAuth) {
    return next('/login')
  }

  if (token) {
    if (
      to.path !== '/login' &&
      !hasCachedUserProfile(userInfo)
    ) {
      try {
        userInfo = await getUserInfo()
      } catch {
        // 接口失败时沿用本地缓存
      }
    }

    // 邀请码未完成前，只允许停留在 login，且不检查产品
    if (needsInviteCodePending()) {
      if (to.path !== '/login') {
        return next('/login')
      }
      return next()
    }

    // 产品未设置：优先于 rules，强制留在 selectBrands
    if (needsBrandSetup() && to.path !== '/selectBrands') {
      return next('/selectBrands')
    }

    if (
      isBrandSetupUnknown() &&
      to.path !== '/selectBrands' &&
      to.path !== '/login'
    ) {
      try {
        const needsSetup = await checkUserBrandSetup()
        if (needsSetup) {
          return next('/selectBrands')
        }
      } catch {
        // 接口失败时不阻断正常导航
      }
    }

    let isAgreed = isUserRulesAgreed(userInfo)
    const needsRules = requiresRulesAgreement()

    // 仅 iThenticate 产品无需规则流程；直接访问 /rules 时重定向到大厅
    if (to.path === '/rules' && !needsRules) {
      return next('/quotationHall')
    }

    // 登录页由 Login.vue 的 resolvePostLoginRoute 处理跳转，不在此拦截
    const shouldCheckRules =
      needsRules &&
      to.path !== '/rules' &&
      to.path !== '/selectBrands' &&
      to.path !== '/login'

    // 本地缓存可能缺少 is_agree，跳转规则页前再拉一次用户信息
    if (shouldCheckRules && !isAgreed) {
      try {
        userInfo = await getUserInfo()
        isAgreed = isUserRulesAgreed(userInfo)
      } catch {
        // 接口失败时沿用本地判断
      }
    }

    if (shouldCheckRules && !isAgreed) {
      return next({
        path: '/rules',
        query: { fromLogin: '1' }
      })
    }
  }
  next()
});
router.afterEach(() => {
  const nextVersion =
    localStorage.getItem('next_version');
  if (nextVersion) {
    localStorage.setItem(
      'app_version',
      nextVersion
    );
    localStorage.removeItem(
      'next_version'
    );
    window.location.reload();
  }
});
export default router
